/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Col_Date1Inputs */

const vi_driverremittance_col_date1 = /** @type {(inputs: Driverremittance_Col_Date1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày`)
};

/**

* @param {Driverremittance_Col_Date1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_col_date1 = /** @type {((inputs?: Driverremittance_Col_Date1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Col_Date1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_col_date1(inputs)
});
export { driverremittance_col_date1 as "driverRemittance_col_date" }